import LineBar from './index.vue'
const codes = ['zxzzt']

export function installLineBar() {
  return codes.map(code => {
    const nameCode = code[0].toUpperCase() + code.substring(1)
    const name = `KyeReport${nameCode}`
    return {
      name,
      extends: LineBar,
      data() {
        return {
          code,
        }
      },
    }
  })
}



// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/echarts/line-bar/install.js